import { hideScrollbar } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

export const HEADING_ID = 'customers-photos-heading';

/* 160px square, from the design. The theme has no sizing scale, so the one value the
   design states is stated here. */
const PHOTO_SIZE = '160px';

/** So a photo's focus ring is not clipped by the scroll container. */
const ITEM_PADDING = '2px';

export const root = css`
  display: flex;
  flex-direction: column;
  row-gap: var(${spacing.sm});
  font-family: var(${typography.body.fontFamily});
  color: var(${colors.content.default});
`;

export const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(${spacing.sm});
`;

export const heading = css`
  margin: 0;
  font-family: var(${typography.heading.fontFamily});
  font-weight: var(${typography.heading.fontWeight});
  font-size: var(${typography.heading.sizes.sm.fontSize});
  line-height: var(${typography.heading.sizes.sm.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
`;

/**
 * Hidden where the device has a touchscreen, as on the product carousels: there a
 * swipe moves the track directly and the arrows would be redundant furniture.
 * `display: none` so the buttons leave the accessibility tree too.
 */
export const controls = css`
  display: flex;
  flex-shrink: 0;
  gap: var(${spacing.xs});

  @media (any-pointer: coarse) {
    display: none;
  }
`;

/**
 * The negative margin and matching padding let the ring of a focused photo show
 * without the track clipping it. `overscroll-behavior-x: contain` stops a swipe that
 * reaches the end from being handed to the page, which on iOS is a back gesture.
 */
export const track = css`
  ${hideScrollbar}

  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  column-gap: var(${spacing.xs});
  margin: -${ITEM_PADDING};
  padding: ${ITEM_PADDING};
  list-style: none;
  scroll-snap-type: x mandatory;
  @media (prefers-reduced-motion: reduce) {
    scroll-behavior: auto;
  }
`;

export const item = css`
  flex: 0 0 auto;
  scroll-snap-align: start;
`;

export const photoLink = css`
  display: block;
  width: ${PHOTO_SIZE};
  height: ${PHOTO_SIZE};
  border-radius: var(${borderRadius.md.mobile});
  /* The image fills the link, so the link has nothing of its own to show. */
  overflow: hidden;

  &:focus-visible {
    outline: var(${themeVariables.strokeWidth}) solid var(${colors.stroke.focus});
    outline-offset: 0;
  }
`;

export const photo = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
